import { useChannelsStore } from '~/stores/channels';
import { DEBUG, GLOBAL_MESSAGE_EVENT, type PayloadDataType } from './index';
import { useHelperStore } from '~/stores/helpers';
import { useUserStore } from '~/stores/auth';
import { useTeamsStore } from '~/stores/teams';

type ManageContact = {
  eventType:
    | 'STUDY_CONTACT_CONFIG_ADDED'
    | 'STUDY_CONTACT_CONFIG_UPDATED'
    | 'STUDY_CONTACT_CONFIG_DELETED'
    | 'ADD_TEAM_NOTIFICATION_CONTACT'
    | 'UPDATE_TEAM_NOTIFICATION_CONTACT'
    | 'DELETE_TEAM_NOTIFICATION_CONTACT';

  channelId: number;
  userId: number;
  teamId: number;
  notificationContactId: number;
};

interface UserState {
  user: {
    summary: {
      basicUserInfo: {
        userId: number;
      };
    };
  };
}

const studyActions = async (channelId: number) => {
  const piniaChannels = useChannelsStore();
  await piniaChannels.fetchStudyActions(channelId);
};
const studyTeamActions = async (channelId: number, teamId: number) => {
  const piniaTeams = useTeamsStore();
  await piniaTeams.fetchStudyTeamActions(channelId, teamId);
};

const fetchContactDetails = async (data, message: string) => {
  const piniaChannel = useChannelsStore();
  const piniaHelper = useHelperStore();
  const emitter = useNuxtApp().$emitter;
  const { status } = piniaHelper.latestResponseStatus as { status: number };
  const channelId = data.channelId;
  const teamId = data.teamId;
  if (teamId) {
    await piniaChannel.getTeamNotificationContacts(channelId, teamId);
  } else {
    await piniaChannel.getStudyNotificationContacts(channelId);
  }

  emitter.$emit(GLOBAL_MESSAGE_EVENT, {
    status,
    eventType: data.eventType,
    message,
    deviceWidth: window?.innerWidth || 0,
  });
};

export async function handleStudyContacts(
  ...[_channel, data]: PayloadDataType<ManageContact>
) {
  if (DEBUG) console.log('handlePusherMessages in studyContactMessage', data);

  const piniaUser = useUserStore() as unknown as UserState;
  const userId = piniaUser.user.summary.basicUserInfo.userId;

  const eventMessages: Record<ManageContact['eventType'], string> = {
    STUDY_CONTACT_CONFIG_ADDED:
      'User has been successfully added as a study contact.',
    STUDY_CONTACT_CONFIG_UPDATED: 'Study contact successfully updated',
    STUDY_CONTACT_CONFIG_DELETED:
      'User has been successfully removed as a study contact.',
    ADD_TEAM_NOTIFICATION_CONTACT:
      'Study Team notification contact added successfully.',
    UPDATE_TEAM_NOTIFICATION_CONTACT:
      'Study Team notification contact updated.',
    DELETE_TEAM_NOTIFICATION_CONTACT:
      'Study Team notification contact removed.',
  };

  if (data.userId === userId && eventMessages[data.eventType]) {
    await fetchContactDetails(data, eventMessages[data.eventType]);
  }
  if (data.eventType === 'STUDY_CONTACT_CONFIG_ADDED') {
    studyActions(data.channelId);
  }
  if (data.eventType === 'ADD_TEAM_NOTIFICATION_CONTACT') {
    studyTeamActions(data.channelId, data.teamId);
  }
}
